const stepInfo = {
  home: {
    name: "K线图",
    seq: 1,
  },
  picture: {
    name: "副图指标",
    seq: 2,
  },
  mastermap: {
    name: "主图指标",
    seq: 3,
  },
  singlefactor: {
    name: "单标的因子分析",
    seq: 4,
  },
  singleanalysis: {
    name: "单天、单因子、多标的分析",
    seq: 5,
  },
  aloneanalysis: {
    name: "单因子分析",
    seq: 6,
  },
  multiplefactor: {
    name: "单天、多因子、多标的分析",
    seq: 7,
  },
  description: {
    name: "实验说明",
    seq: 8,
  },
  code: {
    name: "实验代码",
    seq: 9,
  },
  result: {
    name: "结果示例",
    seq: 10,
  },
  runback: {
    name: "运行回测",
    seq: 11,
  },
};

export default stepInfo
